import { Component } from '@angular/core';

@Component({
    selector: 'app-contacts',
    imports: [],
    templateUrl: './contacts.component.html',
    styleUrl: './contacts.component.scss'
})
export class ContactsComponent {

}
